import React, { useState } from 'react';
import Header from 'pages/home/Header';
import Banner from 'pages/home/Banner';
import Works from 'pages/home/Works';
import Footer from 'pages/home/Footer';
import ProductCatalog from 'pages/home/ProductCatalog';
import RegisterBanner from 'pages/home/RegisterBanner';
import Reviews from 'pages/home/Reviews';
import Integration from 'pages/home/Integration';
import NewProduct from 'pages/home/NewProduct';
import FulfillMent from 'pages/home/Fulfillment';
import ProfitSection from 'pages/home/ProfitSection';
import { Container } from 'styles/pages/home';

const Home = () => {
  const [loginDialog, setLoginDialog] = useState(false);
  const [signUpDialog, setSignUpDialog] = useState(false);
  const [forgotPasswordDialog, setForgotPasswordDialog] = useState(false);

  const toggleLoginDialog = () => setLoginDialog(!loginDialog);
  const toggleSignUpDialog = () => setSignUpDialog(!signUpDialog);
  const toggleForgotPasswordDialog = () =>
    setForgotPasswordDialog(!forgotPasswordDialog);

  return (
    <Container>
      <Header
        loginDialog={loginDialog}
        signUpDialog={signUpDialog}
        forgotPasswordDialog={forgotPasswordDialog}
        toggleLoginDialog={toggleLoginDialog}
        toggleSignUpDialog={toggleSignUpDialog}
        toggleForgotPasswordDialog={toggleForgotPasswordDialog}
      />
      <Banner
        toggleLoginDialog={toggleLoginDialog}
        toggleSignUpDialog={toggleSignUpDialog}
      />
      {/* <ProductCatalog toggleSignUpDialog={toggleSignUpDialog} />
      <NewProduct toggleLoginDialog={toggleLoginDialog} />
      <Works />
      <Integration />
      <FulfillMent />
      <ProfitSection toggleSignUpDialog={toggleSignUpDialog} />
      <Reviews />
      <RegisterBanner toggleSignUpDialog={toggleSignUpDialog} /> */}
      <Footer />
    </Container>
  );
};

export default Home;
